export default __webpack_public_path__ + "static/brush-quotation-f0413783f8c33ff827108ec392f0f186.png";